/* cords2-pdp.js: buy panel behaviour. Reads the variant list, the price map
   and the finish-to-scene map the section prints as JSON, so nothing here
   needs to know the product.

   Prices come pre-formatted from Liquid rather than being formatted here: the
   shop's money format is the shop's currency, and a visitor in another market
   sees a converted one. Formatting client-side printed the right number in the
   wrong currency. */
(function () {
  var form = document.getElementById('c2-buy');
  if (!form) return;
  var root = form.closest('.cords2');
  var holder = document.querySelector('[data-c2-variants]');
  var variants = [];
  try { variants = JSON.parse(holder.textContent); } catch (e) { return; }

  var cfg = {};
  try { cfg = JSON.parse(document.querySelector('[data-c2-labels]').textContent); } catch (e) {}
  var prices = cfg.prices || {};

  var scenes = {};
  var sceneHolder = document.querySelector('[data-c2-scenes]');
  if (sceneHolder) { try { scenes = JSON.parse(sceneHolder.textContent); } catch (e) {} }

  var idField = form.querySelector('[data-c2-variant-id]');
  var addBtn = form.querySelector('[data-c2-add]');
  var addLabel = form.querySelector('[data-c2-addlabel]');
  var priceEl = root.querySelector('.c2-pdp__price-now');
  var finishShot = root.querySelector('[data-c2-shot="finish"] img');
  var sceneWrap = root.querySelector('[data-c2-shot="scene"]');
  var sceneShot = sceneWrap ? sceneWrap.querySelector('img') : null;

  var WIDTHS = [600, 900, 1200, 1600];

  function chosen() {
    return Array.prototype.map.call(
      form.querySelectorAll('[data-c2-opt]:checked'),
      function (i) { return i.value; }
    );
  }

  function match(opts) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i], ok = true;
      for (var j = 0; j < opts.length; j++) {
        if (v.options[j] !== opts[j]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  /* BOTH FRAMES FOLLOW THE SWATCH.

     The first frame is the chosen finish. The old version scrolled the gallery
     to whichever rendered shot matched the variant, which silently did nothing
     whenever that shot was not on screen: the gallery drew the first three
     media, the catalogue holds one photograph per finish, so choosing the
     fourth or fifth finish left the buyer looking at the first.

     The second frame is a scene shot in that same finish. A finish with no
     scene hides the frame rather than showing another colour.

     THE loading ATTRIBUTE IS CLEARED BEFORE EVERY SWAP, and that line is the
     whole reason the scene frame works. The scene renders lazy, which is right
     for a frame below the fold on first paint. But once Chrome has settled a
     lazy image's load state, assigning a new src and srcset does not start a
     new fetch: the element sat there with a correct src, complete false and
     naturalWidth 0, showing nothing. The finish frame never had the problem
     because it renders eager. Promoting the element to eager on first swap
     costs nothing, since by then the visitor has asked for the image.

     Widths are rebuilt from the image's own URL. Shopify's CDN takes width as
     a query parameter, so no second round trip to Liquid is needed. */
  function applySrc(img, url) {
    if (!img || !url) return;
    img.loading = 'eager';
    img.srcset = WIDTHS.map(function (w) {
      return url.replace(/([?&])width=\d+/, '$1width=' + w) + ' ' + w + 'w';
    }).join(', ');
    img.src = url;
  }

  function showFinish(v) {
    if (!finishShot || !v.featured_image || !v.featured_image.src) return;
    var parts = v.featured_image.src.split('?');
    var ver = parts[1] ? parts[1] + '&' : '';
    applySrc(finishShot, parts[0] + '?' + ver + 'width=1600');
    if (v.featured_image.alt) finishShot.alt = v.featured_image.alt;
  }

  function showScene(v) {
    if (!sceneWrap || !sceneShot) return;
    var url = null;
    for (var i = 0; i < v.options.length; i++) {
      if (scenes[v.options[i]]) { url = scenes[v.options[i]]; break; }
    }
    if (!url) { sceneWrap.hidden = true; return; }
    sceneWrap.hidden = false;   /* unhide first: a display:none image never fetches */
    applySrc(sceneShot, url);
  }

  form.addEventListener('change', function (e) {
    if (!e.target.matches('[data-c2-opt]')) return;
    var v = match(chosen());
    if (!v) return;
    idField.value = v.id;
    /* Every option's label, by its position, 20 October 2026. This wrote the
       colour into the first label only, so a length label kept the length
       the page loaded with. Lengths read "2 m", not "2 meters". */
    Array.prototype.forEach.call(root.querySelectorAll('[data-c2-optname]'), function (el) {
      var i = parseInt(el.getAttribute('data-c2-optname'), 10) - 1;
      if (isNaN(i)) i = 0;
      if (v.options[i] != null) el.textContent = String(v.options[i]).replace(/ meters?$/, ' m');
    });
    /* Leave the price alone rather than show an unformatted one. */
    if (priceEl && prices[v.id]) priceEl.textContent = prices[v.id];
    addBtn.disabled = !v.available;
    if (addLabel) addLabel.textContent = v.available ? cfg.add : cfg.sold;

    /* The stock line follows the chosen color, 31 October 2026 (Q-03). */
    var stock = root.querySelector('[data-c2-stock]');
    if (stock) {
      var st = stock.querySelector('[data-c2-stocktext]');
      var vname = v.options.join(', ').replace(/ meters?(?=,|$)/g, ' m');
      if (st) st.textContent = v.available ? stock.getAttribute('data-in') : stock.getAttribute('data-out').replace('[variant]', vname);
      stock.classList.toggle('c2-pdp__dot--out', !v.available);
    }

    showFinish(v);
    showScene(v);

    /* The range band at the foot of the page follows the finish: see
       cords2-card.js. 25 October 2026. */
    try {
      document.dispatchEvent(new CustomEvent('c2:finish', { detail: { options: v.options.slice() } }));
    } catch (err) {}

    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url);
    } catch (err) {}
  });

  form.addEventListener('click', function (e) {
    var b = e.target.closest('[data-c2-qty]');
    if (!b) return;
    var input = form.querySelector('[data-c2-qty-input]');
    var step = parseInt(b.getAttribute('data-c2-qty'), 10);
    input.value = Math.max(1, (parseInt(input.value, 10) || 1) + step);
  });
})()